<template>
  <div class="bg-white p-4">
    <div style="display: grid; grid-template-columns: 1fr 1fr 1fr">
      <div style="display: flex;">
        <div>
          <span v-if="this.form.priceMarkUpOptionState > 0 && !this.ui.show" style="padding: 5px 10px; background: #93C3FF; color: #1A3A85; font-weight: bold; margin-right: 10px" class="text-sm font-medium mr-2 px-2.5 py-0.5 rounded">
            Price Mark Up: {{ this.form.priceMarkUpOptionState }}%
          </span>
        </div>
        <div :style="{marginBottom: this.ui.show ? '20px' : '0px'}">
          <span v-if="this.discount_options != null" style="padding: 5px 10px; background: #F0AD4E; color: #fff; font-weight: bold;" class="text-sm font-medium mr-2 px-2.5 py-0.5 rounded">
            Price Structure: {{ this.discount_options.name }}
          </span>
        </div>
      </div>
      <button
        class="mx-auto text-sm font-semibold text-gray-500"
        @click.prevent="toggleDisplay()"
      >
        {{ this.ui.show ? "Hide Balance" : "Show Balance" }}
      </button>
      <div>
      </div>
    </div>
    <div class="grid grid-cols-4 px-2" :class="{ hidden: !this.ui.show }">
      <div class="col-span-2">
        <div class="mb-8">
          <input
            v-model="form.includeDiscountInPDF"
            id="include-discount-pdf"
            type="checkbox"
            class="mr-2"
          />
          <label for="include-discount-pdf" class="text-sm"
            >Include Discount column in PDF</label
          >
        </div>
        <div>
          <p class="text font-semibold mb-2">Please note:</p>
          <ul class="list-disc list-inside">
            <li class="text-sm">
              All items included below will be displayed in the quote.
            </li>
            <li class="text-sm">
              Items that are selected with checkboxes will be considered for the
              Quote amount summary / totals.
            </li>
            <li class="text-sm">You can rename groups as needed.</li>
          </ul>
        </div>
        <div class="mb-2 mt-8">
          <input
            v-model="form.useProformaInvoiceFormat"
            id="use-proforma-invoice-format"
            type="checkbox"
            class="mr-2"
          />
          <label for="use-proforma-invoice-format" class="text-sm"
            >Use Proforma Invoice Format</label
          >
        </div>
        <div>
          <div>
            <p class="py-3 text-sm">Price Mark Up Option:</p>
          </div>
          <div class="relative">
            <input
              v-model.lazy="form.priceMarkUpOptionState"
              v-money="money"
              :class="{
                'border-gray-200': $v.form.discount.required,
                'border-red-500': !$v.form.discount.required,
                'focus:border-gray-500': $v.form.discount.required,
                'focus:border-red-500': !$v.form.discount.required
              }"
              class="h-full appearance-none block w-full text-right bg-gray-200 text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white max-width-200"
            />
            <div
              class="absolute h-full flex border border-transparent left-0 top-0 w-10"
            >
              <div
                class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full"
              >
                %
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-2 flex">
        <div class="grid grid-flow-row gap-2 w-full">
          <div class="row-span-1 grid grid-cols-4 gap-8 w-full">
            <div class="col-span-3 text-right">
              <p class="py-3 text-sm">Subtotal:</p>
            </div>
            <div class="col-span-1">
              <input
                v-model.lazy="form.subtotal"
                v-money="money"
                class="appearance-none block w-full text-right text-gray-700 rounded p-2 leading-tight outline-none bg-white border-gray-500"
                readonly
              />
            </div>
          </div>
          <div class="row-span-1 grid grid-cols-4 gap-8 w-full">
            <div class="col-span-3 text-right">
              <p class="py-3 text-sm">Discount:</p>
            </div>
            <div class="col-span-1 relative">
              <input
                v-model.lazy="form.discount"
                v-money="money"
                :class="{
                  'border-gray-200': $v.form.discount.required,
                  'border-red-500': !$v.form.discount.required,
                  'focus:border-gray-500': $v.form.discount.required,
                  'focus:border-red-500': !$v.form.discount.required
                }"
                class="h-full appearance-none block w-full text-right bg-gray-200 text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white"
              />
              <div
                class="absolute h-full flex border border-transparent left-0 top-0 w-10"
              >
                <div
                  class="flex items-center justify-center rounded-tl rounded-bl z-10 bg-gray-100 text-gray-600 text-lg h-full w-full"
                >
                  %
                </div>
              </div>
            </div>
          </div>
          <div class="row-span-1 grid grid-cols-4 gap-8 w-full">
            <div class="col-span-1 text-right">
              <p class="py-3 text-sm">Shipping:</p>
            </div>
            <div class="col-span-3 grid grid-flow-row gap-2 w-full">
              <div
                v-for="(shipping, index) in $v.form.shipping.$each.$iter"
                :key="shipping"
                class="grid grid-cols-3 gap-8"
              >
                <div class="col-span-2">
                  <input
                    v-model.lazy="shipping.label.$model"
                    placeholder="Shipping Description"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                  />
                </div>
                <div class="col-span-1">
                  <div class="flex">
                    <input
                      v-model.lazy="shipping.amount.$model"
                      v-money="money"
                      :class="{
                        'border-gray-200': shipping.amount.required,
                        'border-red-500': !shipping.amount.required,
                        'focus:border-gray-500': shipping.amount.required,
                        'focus:border-red-500': !shipping.amount.required
                      }"
                      class="appearance-none block w-full text-right bg-gray-200 text-gray-700 border rounded p-2 leading-tight focus:outline-none focus:bg-white"
                    />
                    <button
                      v-if="index > 0"
                      @click="removeShipping(index)"
                      class="bg-gray-600 py-2 px-2 rounded transition-all duration-500 ease-in-out transform hover:scale-95"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        class="w-6 fill-current text-gray-300"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
                          class="secondary"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="form.shipping.length < 4"
            class="row-span-1 grid grid-cols-4 gap-8 w-full"
          >
            <div class="col-span-1"></div>
            <div class="col-span-3 bg-gray-200 rounded">
              <button
                @click="addShipping()"
                class="mx-auto p-4 text-primary transition-all duration-500 ease-in-out transform hover:scale-95 flex justify-center items-center"
              >
                <AddIcon class="w-6 fill-current text-primary" /> Add an
                additional charge
              </button>
            </div>
          </div>
          <div class="row-span-1 grid grid-cols-4 gap-8 w-full">
            <div class="col-span-3 text-right">
              <p class="py-3 text-sm">Grand Total:</p>
            </div>
            <div class="col-span-1">
              <input
                v-model.lazy="form.grandtotal"
                v-money="money"
                class="appearance-none block w-full text-right text-gray-700 rounded p-2 leading-tight outline-none bg-white border-gray-500"
                readonly
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  name: "ProductsFooter",

  props: {
    lineItems: {
      type: Array
    },
    shipping: {
      type: Array
    },
    discount: {
      type: Number
    },
    includeDiscountInPdf: {
      type: Boolean
    },
    useProformaInvoiceFormat: {
      type: Boolean
    },
    priceMarkUpOption: {
      type: Number
    },
    forceDiscount: {
      type: Number
    },
    discountOptions: {
      type: Object
    }
  },

  data() {
    return {
      ui: {
        show: false
      },

      money: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      },

      form: {
        includeDiscountInPDF: false,
        useProformaInvoiceFormat: false,
        subtotal: 0,
        discount: 0,
        shipping: [],
        grandtotal: 0,
        priceMarkUpOptionState: 0,
        forceDiscount: 1
      },

      discount_options: null
    };
  },

  validations: {
    form: {
      discount: {
        required
      },
      shipping: {
        required,
        maxLength: maxLength(5),
        $each: {
          label: {
            required
          },
          amount: {
            required
          }
        }
      }
    }
  },

  watch: {
    lineItems: {
      handler(val) {
        this.$emit("update-force-discount", 0);
        this.calculateSubtotal(val);
        this.handleIncludesDiscountInPdf(val);
      },
      deep: true
    },

    "form.subtotal"() {
      this.calculateGrandTotal();
    },

    "form.discount"(val) {
      this.calculateGrandTotal();
      this.$emit("update-discount", val);
    },

    "form.shipping": {
      handler(val) {
        this.calculateGrandTotal();
        this.$emit("update-shipping", val);
      },
      deep: true
    },

    "form.includeDiscountInPDF"(val) {
      this.$emit("update-force-discount", 1);
      this.$emit("update-include-discount-in-pdf", val);
    },

    "form.useProformaInvoiceFormat"(val) {
      this.$emit("update-use-proforma-invoice-format", val);
    },

    "form.priceMarkUpOptionState"(val) {
      this.$emit("update-price-mark-up-option", val);
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      //this.form.shipping = Number.parseFloat(this.shipping).toFixed(2);
      this.form.shipping = this.shipping;
      this.form.discount = Number.parseFloat(this.discount).toFixed(2);
      this.form.includeDiscountInPDF = this.includeDiscountInPdf;
      this.form.useProformaInvoiceFormat = this.useProformaInvoiceFormat;
      this.form.priceMarkUpOptionState = Number.parseFloat(this.priceMarkUpOption).toFixed(2);
      this.form.forceDiscount = this.forceDiscount

      if (this.discountOptions) {
        this.discount_options = this.discountOptions;
      }
    },

    toggleDisplay() {
      this.ui.show = !this.ui.show;
    },

    addShipping() {
      this.form.shipping.push({
        label: "",
        amount: 0
      });
    },

    removeShipping(index) {
      this.form.shipping.splice(index, 1);
    },

    calculateSubtotal(lineItems) {
      let subtotal = 0;
      window._.forEach(lineItems, group => {
        if (group.is_deleted) {
          return;
        }
        subtotal =
          subtotal +
          _.sumBy(group.items, lineItem => {
            if (lineItem.active && !lineItem.is_deleted) {
              let subtotal =
                Number.parseInt(lineItem.quantity) *
                (parseFloat(this.form.priceMarkUpOptionState) > 0 ? Number.parseFloat(lineItem.unit_price_calculated) : Number.parseFloat(lineItem.unit_price));
              let discount =
                (subtotal * Number.parseFloat(lineItem.discount)) / 100;
              return subtotal - discount;
            }
            return 0;
          });
      });

      this.form.subtotal = Number.parseFloat(subtotal).toFixed(2);
    },

    calculateGrandTotal() {
      let grandtotal = 0;
      grandtotal = grandtotal + Number.parseFloat(this.form.subtotal);
      grandtotal =
        grandtotal -
        (this.form.subtotal * Number.parseFloat(this.form.discount)) / 100;
      //grandtotal = grandtotal - Number.parseFloat(this.form.discount);
      //grandtotal = grandtotal + Number.parseFloat(this.form.shipping);
      this.form.shipping.forEach(shipping => {
        grandtotal = grandtotal + Number.parseFloat(shipping.amount);
      });

      this.form.grandtotal = Number.parseFloat(grandtotal).toFixed(2);
    },

    handleIncludesDiscountInPdf(lineItems) {
      let allLineItems = _.flatten(
        lineItems.map(lineItem => {
          return lineItem.items;
        })
      );
      let includeDiscountInPDF = false;
      for (let i = 0; i < allLineItems.length; i++) {
        const lineItem = allLineItems[i];
        if (Number.parseFloat(lineItem.discount) > 0) {
          includeDiscountInPDF = true;
          break;
        }
      }
      
      this.form.includeDiscountInPDF = includeDiscountInPDF;
      /* console.log(this.form.includeDiscountInPDF); */
    }
  }
};
</script>
